$(() => {
  const $callout = $('.callout[role="alert"]:first');
  if ($callout.length > 0) {
    setTimeout(() => {
      $callout.attr("tabindex", "0").focus().html(`${$callout.html()}&nbsp;`);
    }, 500);
  }
});
